/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import config from '../config/sidebarItems.config.json';
import { StorageModule } from '@vlinder-web/storage-module-react';

interface ISidebarProps {
  whoami: string;
}

export interface ISidebarMethods extends IPluginMethodMap {
  getSidebarItems(args: ISidebarProps): Promise<any>;
}

export class SidebarItemService implements IAgentPlugin {
  readonly methods: ISidebarMethods;

  constructor() {
    this.methods = {
      getSidebarItems: this.getSidebarItems.bind(this),
    };
  }

  async getSidebarItems(args: ISidebarProps) {
    // const { whoami } = args;
    const items = config.sidebarItems;
    const _items: any = [];
    const storageSrv = StorageModule.getInstance();
    console.log('myProfile', storageSrv?.get('myProfile', 'local'));
    const email = storageSrv?.get('myProfile', 'local')?.email;
    console.log('myProfile email', email);
    const whoami = email === 'admin@excise.com' ? 'holder' : 'admin';
    for (let i = 0; i < items?.length; ++i) {
      const _item: any = items[i];
      if (_item?.id) {
        if (!this.isBlackListFound(whoami, _item?.id)) {
          _items.push(_item);
        }
      }
      // else if (_item?.children) {
      //   const _children: any = [];
      //   _childItem.title = ""
      //   if (_childItem?.id) {
      //     if (!this.isBlackListFound(whoami, _childItem?.id)) {
      //       _children.push(_childItem);
      //     }
      //   }
      //   const _temp = { ..._item };
      //   _temp.children = _children;
      //   _items.push(_temp);
      // }
      else {
        _items.push(_item);
      }
    }
    return { sidebarItems: _items };
  }

  private isBlackListFound(whoami: string, id: string) {
    let _found = false;
    // @ts-ignore
    const blacklist = config['blacklistItems'][whoami];
    if (blacklist) {
      if (blacklist.find((bl: any) => bl == id)) {
        _found = true;
      }
    }
    return _found;
  }
}
